import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * Syntax sugar.
 * Allows to use brackets in WHERE expressions for better syntax.
 */
export var Brackets = /*#__PURE__*/_createClass(
/**
 * Given WHERE query builder that will build a WHERE expression that will be taken into brackets.
 */
function Brackets(whereFactory) {
  _classCallCheck(this, Brackets);
  this["@instanceof"] = Symbol.for("Brackets");
  this.whereFactory = whereFactory;
});